<template>
  <div class="q-container-fluid q-pb-2 ">
    <div class="serp__filters--marked-container q-justify-content-between  q-flex-wrap q-col-12 ">
      <MarkedFilterItem/>
    </div>
  </div>
</template>

<script setup lang="ts">
import MarkedFilterItem from './MarkedFilterItem.vue'
</script>
